import { render, staticRenderFns } from "./DiscountConfig.vue?vue&type=template&id=a87f8d10&"
import script from "./DiscountConfig.vue?vue&type=script&lang=js&"
export * from "./DiscountConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports